import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import AuthLayout, { Field, inputCls } from "@/pages/AuthLayout";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Recover Access"
      subtitle="We will dispatch a secure reset wire to your registered address."
      footer={<Link to="/login" className="text-[#F1551D] hover:underline">Back to sign in</Link>}
    >
      {done ? (
        <div className="text-center py-4" data-testid="forgot-done">
          <p className="text-[#2f5561] text-sm leading-relaxed">If that email is registered, a reset link has been sent. Please check your inbox and follow the secure link within one hour.</p>
        </div>
      ) : (
        <form onSubmit={submit}>
          <Field label="Institutional Email">
            <input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="you@institution.org" />
          </Field>
          <button data-testid="forgot-submit-btn" disabled={loading} className="w-full py-2.5 rounded-lg btn-gold font-semibold disabled:opacity-60">
            {loading ? "Dispatching…" : "Send Reset Wire"}
          </button>
        </form>
      )}
    </AuthLayout>
  );
}
